import type { DefaultTheme } from "styled-components";

import {
  resolveCollectionFrameRecipe,
  resolveCollectionRowRecipe,
  type CollectionFrameRecipe,
  type CollectionRowRecipe,
} from "../foundations/collectionAppearance";
import type { DataTableAppearance, DataTableRowAppearance } from "./types";

export type DataTableAppearanceRecipe = CollectionFrameRecipe;

// 부모와 노출된 자식을 하나의 group으로 배치하는 geometry는 DataTable이 소유한다.
export type RowAppearanceRecipe = CollectionRowRecipe & {
  gap: string;
  headerGap: string;
  groupEndDividerWidth: string;
};

export function resolveDataTableAppearanceRecipe(
  theme: DefaultTheme,
  appearance: DataTableAppearance,
): DataTableAppearanceRecipe {
  return resolveCollectionFrameRecipe(theme, appearance);
}

export function resolveDataTableRowAppearanceRecipe(
  theme: DefaultTheme,
  rowAppearance: DataTableRowAppearance,
): RowAppearanceRecipe {
  return {
    ...resolveCollectionRowRecipe(theme, rowAppearance),
    ...(rowAppearance === "raised"
      ? {
          gap: "0.125rem",
          // body group gap보다 header boundary를 넓혀 독립 row surface를 분리한다.
          headerGap: "0.25rem",
          groupEndDividerWidth: "0px",
        }
      : { gap: "0px", headerGap: "0px", groupEndDividerWidth: "1px" }),
  };
}
